import { type SystemStyleObject } from '@chakra-ui/react/styled-system';

import { rem } from '../themeUtils';

export const base = {
  content: {
    background: 'background/primary',
    border: '1px solid',
    borderColor: 'border/minimal',
    borderRadius: '4',
    zIndex: 'select',
    overflowY: 'auto',
    boxShadow: 'elevation/lg',
    _open: {
      animationStyle: 'slide-fade-in',
      animationDuration: 'fast',
    },
    _closed: {
      animationStyle: 'slide-fade-out',
      animationDuration: 'fastest',
    },
  },
  item: {
    position: 'relative',
    userSelect: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: '12',
    cursor: 'pointer',
    justifyContent: 'space-between',
    flex: '1',
    textAlign: 'start',
    lineHeight: rem(24),
    _highlighted: {
      bg: 'background/hover',
    },
    _selected: {
      bg: 'background/selected',
    },
  },
  itemIndicator: {
    alignItems: 'center',
    color: 'icon/interactive',
    display: 'flex',
    justifyContent: 'center',
  },
} satisfies Record<string, SystemStyleObject>;

export const variants = {
  size: {
    lg: {
      item: {
        paddingInline: '16',
        paddingBlock: '12',
        textStyle: 'body/lg/regular',
        _selected: {
          textStyle: 'body/lg/semibold',
        },
      },
      itemIndicator: {
        width: '24',
        height: '24',
      },
    },
    md: {
      item: {
        paddingBlock: '8',
        paddingInline: '16',
        textStyle: 'body/md/regular',
        _selected: {
          textStyle: 'body/md/semibold',
        },
      },
      itemIndicator: {
        width: '16',
        height: '16',
      },
    },
  },
} satisfies Record<'size', Record<'md' | 'lg', Record<string, SystemStyleObject>>>;
